export const getFlags = (flags, featureFlags) => {
    return (
        Object.keys(flags).reduce(
            (result, flagKey) => ({
                ...result,
                [flagKey]:
                    featureFlags[flags[flagKey]] !== undefined &&
                    featureFlags[flags[flagKey]] !== 'default'
                        ? featureFlags[flags[flagKey]]
                        : false,
            }),
            {},
        ) || {}
    );
};

export default {
    getFlags,
};
